import { render, staticRenderFns } from "./aigBirthdayTable.vue?vue&type=template&id=db5f43d8&scoped=true&"
import script from "./aigBirthdayTable.vue?vue&type=script&lang=js&"
export * from "./aigBirthdayTable.vue?vue&type=script&lang=js&"
import style0 from "./aigBirthdayTable.vue?vue&type=style&index=0&id=db5f43d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5f43d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VContainer,VDataTable,VIcon})
